

























import Vue from "vue";
import { AlertBar } from "@ct/alert";
import AdminManagementTable from "@/components/AdminManagementTable.vue";
import CmsContent from "@/components/CmsContent.vue";
import { Component } from "vue-property-decorator";

@Component({
  name: "AdminManagementPortal",
  components: { AlertBar, AdminManagementTable, CmsContent }
})
export default class AdminManagementPortal extends Vue {}
